import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { mergeConfigs, colorFactory } from '@shopify/polaris-tokens/dist-modern';
import { config } from '@shopify/polaris-tokens/dist-modern/configs/base';
function buildCustomPropertiesNoMemo(themeConfig, tokens) {
  const {
    colors = {},
    colorScheme,
    config: config$1,
    frameOffset = '0px'
  } = themeConfig;
  const mergedConfig = mergeConfigs(config, config$1 || {});
  return customPropertyTransformer(_objectSpread2(_objectSpread2(_objectSpread2({}, colorFactory(colors, colorScheme, mergedConfig)), tokens), {}, {
    frameOffset
  }));
}
function buildThemeContext(themeConfig, cssCustomProperties) {
  const {
    logo,
    colors = {},
    colorScheme
  } = themeConfig;
  return {
    logo,
    cssCustomProperties: toString(cssCustomProperties),
    colors,
    colorScheme
  };
}
function toString(obj) {
  if (obj) {
    return Object.entries(obj).map(pair => pair.join(':')).join(';');
  } else {
    return '';
  }
}
function customPropertyTransformer(properties) {
  return Object.entries(properties).reduce((transformed, _ref) => {
    let [key, value] = _ref;
    return _objectSpread2(_objectSpread2({}, transformed), {}, {
      [toCssCustomPropertySyntax(key)]: value
    });
  }, {});
}
function toCssCustomPropertySyntax(camelCase) {
  return `--p-${camelCase.replace(/([A-Z0-9])/g, '-$1').toLowerCase()}`;
} // eslint-disable-next-line @typescript-eslint/ban-types

function memoize(fnToMemoize) {
  const cache = new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const key = JSON.stringify([fnToMemoize.name, args]);
    if (cache.get(key) === undefined) {
      cache.set(key, fnToMemoize(...args));
    }
    return cache.get(key);
  };
}
const buildCustomProperties = memoize(buildCustomPropertiesNoMemo);
export { buildCustomProperties, buildCustomPropertiesNoMemo, buildThemeContext, toCssCustomPropertySyntax, toString };